import { z } from "zod";

export const officeValidation = z.object({
  name: z.string().min(1),
  code: z.string().nullable().optional(),
  city: z.object({
    connect: z.string(),
  }),
  supplier: z.object({
    connect: z.string(),
  }),
  email: z.email().nullable().optional(),
  phone: z.string().nullable().optional(),
  address: z.object({
    upsert: z.object({}),
  }),
});
